import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { MatchContactsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { MatchContactsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const matchContacts = (request: MatchContactsRequest, options?: CashRequestOptions) =>
  post<MatchContactsRequest, MatchContactsResponse>('/2.0/cash/match-contacts', request, {
    ...options,
    rejectOnError: true,
  })
